module.exports = __webpack_public_path__ + "img/logo_mini.1c8c713d.svg";